import React, { useEffect, useRef, useState } from "react";
import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import MastersFilterModal from "modals/MastersFilterModal";
import toast from "react-hot-toast";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useDispatch } from "react-redux";
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import { deleteUserData } from "_services/userService";
import useDocumentTitle from "hooks/useDocumentTitle";
import { EditUserProfile } from "modals";
import { getActiveSessions, getUserContact } from "_services";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Contact = () => {
  useDocumentTitle("User | MySifarish");
  const getMasterDataList = JSON.parse(localStorage.getItem("masterData"));
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [userListData, setUserListData] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccessMsg, setIsSuccessMsg] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [persistedState, setPersistedState] = useState(location);
  const [exportLoad, setExportLoad] = useState(false);

  // const [selectedRange, setSelectedRange] = useState({
  //   startDate: moment().startOf("month"),
  //   endDate: moment().endOf("month"),
  // });

  // const [filter, setFilter] = useState({
  //   userId: "",
  //   page: 1,
  //   limit: 20,
  //   startDate: null,
  //   endDate: null,
  //   isActive: "",
  //   // isRegistered: "",
  // });

  //   useEffect(() => {
  //     if (getUserData?._id) {
  //     //   fetchActiveSession();
  //       //   fetchlistUserData(getUserData._id);
  //       fetchUserContact(getUserData._id);
  //     }
  //   }, [getUserData?._id, filter]);

  //   useEffect(() => {
  //     const id = location?.state?._id;

  //     if (id) {
  //       fetchUserContact(id);
  //     } else {
  //       fetchUserContact();
  //     }
  //   }, [filter]);

  const debounceRef = useRef(null);

  const initialFilter = {
    userId: "",
    page: 1,
    limit: 20,
    startDate: null,
    endDate: null,
    keyword: "",
    isActive: "",
    isRegistered:""
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [filter, setFilter] = useState({
    ...initialFilter,
    userId: searchParams.get("userId") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 20,
    isActive: searchParams.get("isActive") || "",
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate"))
      : "",
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate"))
      : "",
    keyword: searchParams.get("keyword") || "",
    isRegistered: searchParams.get("isRegistered") || "",
  });

  const [selectedRange, setSelectedRange] = useState({
    startDate: filter.startDate,
    endDate: filter.endDate,
  });

  useEffect(() => {
    const params = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !(moment.isMoment(value) && !value.isValid())
      ) {
        params[key] = moment.isMoment(value)
          ? value.format("YYYY-MM-DD")
          : value;
      }
    });

    setSearchParams(params);
  }, [filter, setSearchParams]);

  const handleReset = () => {
    setFilter(initialFilter);
    setSearchParams({});
    setSelectedRange({ startDate: null, endDate: null });
  };

  const hasActiveFilters = Object.keys(initialFilter).some((key) => {
    if (key === "page" || key === "limit") return false;

    const currentValue = filter[key];
    const initialValue = initialFilter[key];

    const normalize = (val) =>
      val === "" || val === null || val === undefined ? null : val;

    const curr = normalize(currentValue);
    const init = normalize(initialValue);

    if (moment.isMoment(curr)) {
      return (
        curr.isValid() && (!moment.isMoment(init) || !curr.isSame(init, "day"))
      );
    }

    return curr !== init;
  });

  useEffect(() => {
    const id = persistedState?.state?._id;

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (id) {
        fetchUserContact(id);
      } else {
        fetchUserContact();
      }
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [filter]);

  useEffect(() => {
    if (location?.state && !persistedState) {
      setPersistedState(location);
    }
  }, [location.state]);

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];

    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination">
        <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchActiveSession = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        startDate: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        endDate: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        userId: data ? data : filter?.userId ? filter?.userId : "",
        isActive: filter?.isActive,
      };
      const res = await getActiveSessions(payload);
      if (res) {
        setUserListData(res?.data?.sessions);
        setTotalCount(res?.data?.totalRecords);
        setLoading(false);
      } else {
        toast.error(res?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const fetchUserContact = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        userIdToFetch: data
          ? data
          : filter?.userIdToFetch
          ? filter?.userIdToFetch
          : "",
        userId: getUserData._id,
        // isFromAdmin: true,
      };
      const res = await getUserContact(payload);
      if (res) {
        setUserListData(res?.data?.contacts);
        setTotalCount(res?.data?.totalRecords);
        setLoading(false);
      } else {
        toast.error(res?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      userIdToDelete: isDelete?._id,
    };
    try {
      const res = await deleteUserData(payload);
      if (res) {
        fetchUserContact(getUserData._id);
        setIsDelete(false);
        setIsSuccessMsg(res?.message);
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setIsDelete(false);
    }
  };

  const propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
  };

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const columns = [
    { header: "", accessor: "serial" },
    { header: "Contact Name", accessor: "contactName" },
    { header: "Contact Number", accessor: "contactPhoneNumber" },
    { header: "User Name", accessor: "userName" },
    { header: "Active", accessor: "isActive" },
    { header: "Deleted", accessor: "isDeleted" },
    { header: "Registered", accessor: "isRegistered" },
    { header: "Joined Date", accessor: "createdAt" },
  ];

  const rowListData = (data) =>
    data?.map((item, i) => ({
      ...item,
      serial: (
        <div className="signDropdown">
          {/* <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button> */}
        </div>
      ),
      contactName: item?.contactName || "-",
      userName: (
        <>
          {item?.userId === null ? (
            "User Deleted"
          ) : (
            <>{`${item?.userId?.firstName} ${item?.userId?.lastName}`}</>
          )}
        </>
      ),
      contactPhoneNumber: item?.contactPhoneNumber || "-",
      isActive: item?.isActive ? "Yes" : "No",
      isDeleted: item?.isDeleted ? "Yes" : "No",
      isRegistered: item?.isRegistered ? "Yes" : "No",
      createdAt: formatDateToDDMMYYYY(item?.createdAt) || "-",
    }));

  const exportToCSV = async () => {
    const loadingToast = toast.loading(
      "Please wait, Contacts are getting exported..."
    );

    setExportLoad(true);
    try {
      const payload = {
        ...filter,
        userIdToFetch: persistedState?.state?._id || "",
        userId: getUserData._id,
        page: 1,
        limit: 10000,
      };

      const firstRes = await getUserContact(payload);

      if (
        !firstRes ||
        !firstRes.data?.contacts ||
        firstRes.data.contacts.length === 0
      ) {
        toast.dismiss(loadingToast);
        toast.error("No data to export!");
        setExportLoad(false);
        return;
      }

      const totalPages = firstRes.data.totalPages || 1;
      const totalRecords =
        firstRes.data.totalRecords || firstRes.data.contacts.length;
      toast.dismiss(loadingToast);
      toast.success(
        `Exporting ${totalRecords} records in ${totalPages} chunks...`
      );

      let allData = [...firstRes.data.contacts];

      for (let page = 2; page <= totalPages; page++) {
        let success = false;
        let retries = 3;

        while (!success && retries > 0) {
          try {
            const res = await getUserContact({ ...payload, page });
            if (res?.data?.contacts?.length) {
              allData = [...allData, ...res.data.contacts];
            }
            success = true;
          } catch (err) {
            console.warn(`Retrying page ${page}... (${3 - retries + 1})`);
            retries--;
            await new Promise((r) => setTimeout(r, 1000));
          }
        }
      }

      const chunkSize = 50000;
      const numFiles = Math.ceil(allData.length / chunkSize);

      for (let i = 0; i < numFiles; i++) {
        const chunk = allData.slice(i * chunkSize, (i + 1) * chunkSize);

        const filterSummary = [
          {
            Key: "Registered",
            Value:
              filter?.isRegistered === 1
                ? "Yes"
                : filter?.isRegistered === 0
                ? "No"
                : "All",
          },
          { Key: "Searched Word", Value: filter?.keyword || "-" },

        ];

        const formattedData = chunk.map((item, index) => ({
          "Serial No": i * chunkSize + index + 1,
          "Contact Name": item?.contactName || "-",
          "Contact Number": item?.contactPhoneNumber || "-",
          "User Name":
            item?.userId === null
              ? "User Deleted"
              : `${item?.userId?.firstName} ${item?.userId?.lastName}`,
          Active: item?.isActive ? "Yes" : "No",
          Deleted: item?.isDeleted ? "Yes" : "No",
          Registered: item?.isRegistered ? "Yes" : "No",
          "Joined Date": formatDateToDDMMYYYY(item?.createdAt) || "-",
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([], { skipHeader: true });

        const keyColumn = "C";
        const valueColumn = "E";

        ws[`${keyColumn}1`] = { t: "s", v: "Filter Type" };
        ws[`${valueColumn}1`] = { t: "s", v: "Filter Value" };

        filterSummary.forEach((item, index) => {
          const rowNum = index + 3;
          ws[`${keyColumn}${rowNum}`] = { t: "s", v: item.Key };
          ws[`${valueColumn}${rowNum}`] = { t: "s", v: item.Value };
        });

        XLSX.utils.sheet_add_json(ws, formattedData, {
          origin: "A9",
          skipHeader: false,
        });

        const dataOnly = formattedData.map((r) => r);
        XLSX.utils.sheet_add_json(ws, dataOnly, {
          origin: "A10",
          skipHeader: true,
        });

        ws["!cols"] = [
          { wch: 10 },
          { wch: 30 },
          { wch: 20 },
          { wch: 30 },
          { wch: 10 },
          { wch: 10 },
          { wch: 12 },
          { wch: 20 },
        ];

        XLSX.utils.book_append_sheet(wb, ws, `Contacts_${i + 1}`);
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        const epochTime = Date.now();
        saveAs(blob, `Contact_List_Part_${i + 1}_${epochTime}.xlsx`);
      }
      toast.success("All CSV files downloaded successfully!");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error?.message || "Something went wrong during export.");
    } finally {
      setExportLoad(false);
    }
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
    }));
  };

  const EditUserModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Edit User",
    footerPart: true,
    submitTitle: "Edit User",
    onSuccess: () => fetchUserContact(getUserData._id),
  };

  const handleRemoveTitle = () => {
    navigate(persistedState.pathname, { replace: true });
    fetchUserContact();
    setPersistedState(null);
  };
  return (
    <>
      <ButtonHeading
        title={`Contact `}
        titleName={`${
          persistedState?.state?._id ? persistedState?.state?.firstName : ""
        } ${persistedState?.state?._id ? persistedState?.state?.lastName : ""}`}
        handleRemoveTitle={() => handleRemoveTitle()}
        showCross={persistedState?.state?._id ? true : false}
        //   showDateRange={true}
        exportLoad={exportLoad}
        Export={true}
        ExportSubmit={exportToCSV}
        //   selectedRange={selectedRange}
        filter={filter}
        setFilter={setFilter}
        handleApply={handleApply}
        userDataList={userDataList}
        isShow={{
          keyword: true,
          isRegistered: true,
        }}
        handleReset={() => handleReset()}
        showResetFilter={hasActiveFilters}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(userListData?.length > 0 ? userListData : [])}
          isLoading={loading}
          colSpan={8}
        />
        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isOpen && userToEdit && (
        <EditUserProfile
          userId={getUserData?._id}
          userIdToUpdate={userToEdit._id}
          userData={userToEdit}
          props={EditUserModal}
        />
      )}

      {isDelete?._id && (
        <CommonModal {...propsDelete}>
          <p className="p-3">
            {" "}
            Are you sure to delete this user {isDelete?.firstName}?
          </p>
        </CommonModal>
      )}
    </>
  );
};

export default Contact;
